import { Dropdown, IDropdownOption, IDropdownProps, IStackTokens, Label, Stack } from "@fluentui/react";
import React from "react";
import styles from "../../styles/stationSelector.module.css";

export interface CafeSelectorViewProps {
  regionOptions: IDropdownOption[];
  cafeOptions: IDropdownOption[];
  onRegionSelect: (option?: IDropdownOption) => void;
  onCafeSelect: (option?: IDropdownOption) => void;
  selectedRegionId?: string;
  selectedCafeId?: string;
}

const CafeSelectorView = ({
  regionOptions,
  cafeOptions,
  onRegionSelect,
  onCafeSelect,
  selectedRegionId,
  selectedCafeId,
}: CafeSelectorViewProps) => {
  // This determines how the Stack option displays the items within it
  const innerStackTokens: IStackTokens = {
    childrenGap: "10 0",
    maxWidth: "100%",
  };
  const OuterStackTokens: IStackTokens = {
    childrenGap: "35 0",
    maxWidth: "100%",
    padding: 15,
  };

  const onRenderTopLabel = (props: IDropdownProps): JSX.Element => {
    /* eslint-disable react/prop-types */
    return <Label className={styles.noTopPadding}>{props.label}</Label>;
  };

  return (
    <Stack horizontalAlign="stretch" verticalAlign="start" tokens={OuterStackTokens} verticalFill={true}>
      <Stack horizontalAlign="stretch" verticalAlign="start" tokens={innerStackTokens}>
        <Dropdown
          label="Choose a Region"
          placeholder="Choose a region..."
          options={regionOptions}
          defaultSelectedKey={selectedRegionId}
          onRenderLabel={onRenderTopLabel}
          onChange={(_e, option) => onRegionSelect(option)}
          disabled={!regionOptions || !regionOptions.length}
          data-testid="regionDropdown"
        />
        <Dropdown
          label="Choose a Cafe"
          placeholder="Choose a cafe..."
          options={cafeOptions}
          notifyOnReselect={true}
          defaultSelectedKey={selectedCafeId}
          disabled={!cafeOptions || !cafeOptions.length}
          onChange={(_e, option) => onCafeSelect(option)}
          data-testid="cafeDropdown"
        />
      </Stack>
    </Stack>
  );
};

export default CafeSelectorView;
